// eslint-disable-next-line @nx/enforce-module-boundaries
import { useRichText, type UseRichTextProps } from '@capsicum/common';
import { type CSSProperties, type FC, type PropsWithChildren } from 'react';
import { styled } from 'styled-components';

type RichTextProps<T> = UseRichTextProps<T> & { style?: CSSProperties; textEl?: FC<PropsWithChildren<{}>> };

/**
 * @example <RichText<{ 'another-attribute-from-text': string }>
				interpolate={{
					link: ({ text, href, ...props }) => (
						<Link href={href!} testID={props['another-attribute-from-text']}>
							{text}
						</Link>
					),
					bold: ({ text }) => <div style={{ fontWeight: 'bold' }}>{text}</div>,
					cta: ({ text }) => <Button testID="testID" text={text} onClick={() => console.log('pressed')} />
				}}
			>
				{txt}
			</RichText>
 * @returns
 */
export const RichText = <T = {},>({ style, textEl: Wrapper, ...props }: RichTextProps<T>) => {
	const elements = useRichText(props);

	if (Wrapper) {
		return <Wrapper>{elements}</Wrapper>;
	}

	return (
		<S.Text style={style} {...props}>
			{elements}
		</S.Text>
	);
};

namespace S {
	export const Text = styled.p``;
}
